<template>
    <Error
        icon="cogs"
        title="Policy System Not Yet Configured"
        subtitle="501: Not Implemented"
    >
        <!-- Description of the error -->
        <slot />

        <template #actions>
            <!-- Action buttons or links to be shown below the error message -->
            <slot name="actions" />
        </template>
    </Error>
</template>

<script>
    import {library} from '@fortawesome/fontawesome-svg-core';
    import {faCogs} from '@fortawesome/pro-solid-svg-icons';

    import Error from '../Error.vue';

    library.add(faCogs);

    /**
     * @group Errors
     * This should be used when a Policy System is not fully set up/configured.
     */
    export default {
        name: 'PolicySystemNotConfigured',
        components: {
            Error,
        },
    };
</script>
